import { Link } from "react-router-dom";
import "./Learn.scss";
import InnerNav from "../components/InnerNav/InnerNav";
import Footer from "../components/Footer/Footer";
import Zodiac from "../components/ZodiacSign/Zodiac";

const Learn = () => {
  return (
    <div className="learn-container">
        <InnerNav/>
        <div className="learn-content">
          <Zodiac/>
      <div className="learn-header">
        
        <h2>Learn Astrology</h2>
        <p>
          Astrology is the ancient study of celestial movements and their
          influence on human life. Here you’ll find beginner-friendly lessons
          and resources to understand the basics of astrology, birth charts, and
          planetary effects.
        </p>
      </div>

      <div className="learn-section">
        <h3>Video Lessons</h3>
        <div className="video-grid">
          <Link to="/learn/video5" className="video-card">
            <div className="thumb">✨</div>
            <p>Ascendant & Rising Signs</p>
          </Link>

          <Link to="/learn/video6" className="video-card">
            <div className="thumb">☀️</div>
            <p>The Role of the Sun in Astrology</p>
          </Link>

          <Link to="/learn/video7" className="video-card">
            <div className="thumb">🌑</div>
            <p>The Moon and Your Emotions</p>
          </Link>

          <Link to="/learn/video8" className="video-card">
            <div className="thumb">♂</div>
            <p>Mars: Energy & Action</p>
          </Link>

          <Link to="/learn/video9" className="video-card">
            <div className="thumb">♀</div>
            <p>Venus: Love & Relationships</p>
          </Link>

          <Link to="/learn/video10" className="video-card">
            <div className="thumb">♃</div>
            <p>Jupiter: Growth & Wisdom</p>
          </Link>

          <Link to="/learn/video11" className="video-card">
            <div className="thumb">♄</div>
            <p>Saturn: Karma & Discipline</p>
          </Link>

          <Link to="/learn/video12" className="video-card">
            <div className="thumb">📈</div>
            <p>12 Houses in Astrology</p>
          </Link>

          <Link to="/learn/video13" className="video-card">
            <div className="thumb">🌀</div>
            <p>Rahu & Ketu: Shadow Planets</p>
          </Link>

          <Link to="/learn/video14" className="video-card">
            <div className="thumb">🔮</div>
            <p>Introduction to Nakshatras</p>
          </Link>

          <Link to="/learn/video15" className="video-card">
            <div className="thumb">🧿</div>
            <p>Astrological Remedies & Gemstones</p>
          </Link>

          <Link to="/learn/video16" className="video-card">
            <div className="thumb">📖</div>
            <p>Practical Guide to Horoscope Reading</p>
          </Link>

          <Link to="/learn/video17" className="video-card">
            <div className="thumb">🌍</div>
            <p>Elements & Modalities Explained</p>
          </Link>

          <Link to="/learn/video18" className="video-card">
            <div className="thumb">🕰️</div>
            <p>Dasha System: Planetary Periods</p>
          </Link>

          <Link to="/learn/video19" className="video-card">
            <div className="thumb">⚖️</div>
            <p>Compatibility & Synastry in Astrology</p>
          </Link>


        </div>
      </div>
      
    </div>
    <Footer/>
    </div>
  );
};

export default Learn;
